/* istanbul ignore file */

export { PageHeader as default } from "./PageHeader";
